<template>
  <div class="image_container" v-if="isShowViewer">
    <ArrowLeftOutlined class="image_back" @click.stop="closeViewer" />
    <div class="image_wrapper">
      <div class="image_content">
        <img
          class="image_player"
          :class="{ image_player_h: currentImageType == 'h', image_player_v: currentImageType == 'v' }"
          :src="currentUrl"
          @load="getImageType"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowLeftOutlined } from '@ant-design/icons-vue';
import { ref, defineExpose, onBeforeUnmount } from 'vue';

const isShowViewer = ref(false);

const currentUrl = ref('');
const currentImageType = ref('');

// 记录打开前的 body 内联 overflow，关闭/卸载时原样还原：
// 直接写 'auto' 会覆盖全局 overflow-x:hidden 兜底，且组件卸载时可能永远锁住页面
let bodyOverflowBackup = null;
const lockBodyScroll = () => {
  if (bodyOverflowBackup !== null) return;
  bodyOverflowBackup = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
};
const restoreBodyScroll = () => {
  if (bodyOverflowBackup === null) return;
  document.body.style.overflow = bodyOverflowBackup;
  bodyOverflowBackup = null;
};

const openViewer = (url) => {
  currentUrl.value = url;
  isShowViewer.value = true;
  lockBodyScroll();
};

const closeViewer = () => {
  isShowViewer.value = false;
  restoreBodyScroll();
};

onBeforeUnmount(restoreBodyScroll);

const getImageType = () => {
  const img = event.target;

  const width = img.naturalWidth;
  const height = img.naturalHeight;

  if (width > height) {
    currentImageType.value = 'h';
  } else {
    currentImageType.value = 'v';
  }
};

defineExpose({
  openViewer,
  closeViewer,
});
</script>

<style lang="less" scoped>
.image_container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  .image_back {
    font-size: 18px;
    color: #fff;
    position: absolute;
    left: 30px;
    top: 30px;
  }
  .image_wrapper {
    margin: 0 auto;
    padding: 0 200px;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    align-items: center;
    justify-content: center;
    max-width: 2560px;
    .image_content {
      text-align: center;
      width: calc(100% - 218px);
      height: calc(100% - 100px);
      display: flex;
      align-items: center;
      justify-content: center;
      .image_player {
        border-radius: 8px;
      }
      .image_player_h {
        max-width: 100%;
      }
      .image_player_v {
        max-height: 100%;
      }
    }
    .image_list {
      width: 188px;
      margin-left: 30px;
      margin-top: 30px;
      max-height: 80%;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
      .image_item {
        width: 100%;
        margin: 24px auto;
        cursor: pointer;
        position: relative;
        .item_player {
          width: 100%;
          height: 108px;
          border-radius: 8px;
          background: #333333;
        }
        .item_title {
          font-size: 12px;
          font-weight: 500;
          color: #fff;
          margin-top: 12px;
        }
        .video_duration {
          color: #ffffff;
          font-size: 12px;
          background: #000000;
          border-radius: 2px;
          position: absolute;
          top: 75px;
          right: 15px;
          padding: 2px 5px;
        }
      }
      .video_playing {
        border: 4px solid #05644f;
      }
    }
  }
  @media (max-width: 1080px) {
    .image_wrapper {
      margin: 0 auto;
      padding: 0 100px;
    }
  }
  @media (max-width: 780px) {
    .image_wrapper {
      .image_content {
        width: 100%;
      }
      .image_list {
        display: none;
      }
    }
  }
}
</style>
